/**
 * Centralized path builders for Videa Notes API.
 * No auth or base URL; only path segments for use with adapter.getBaseUrl().
 */
export const paths = {
  videaNoteById: (id: string) => `/videa-notes/${id}`,
  videaNoteSummary: (id: string) => `/videa-notes/${id}/summary`,
  videaNoteFeedback: (id: string) => `/videa-notes/${id}/feedback`,
  videaNoteWriteback: (id: string) => `/videa-notes/${id}/writeback`,
  videaNotesWriteback: () => '/videa-notes/writeback',
  appointmentNotes: (unifiedAppointmentId: string) =>
    `/videa-notes/appointment-notes/${unifiedAppointmentId}`,
  standaloneVisitNotes: (standalonePatientVisitId: string) =>
    `/videa-notes/standalone-patient-visit-notes/${standalonePatientVisitId}`,
  voiceNoteTemplates: (namespace?: string) =>
    namespace
      ? `/voice-note-templates?namespace=${encodeURIComponent(namespace)}`
      : '/voice-note-templates',
  standalonePatientVisits: () => '/standalone-patient-visits',
} as const;
